import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const FeaturesAlternating: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const features = (c.features || []) as Array<{ title: string; description: string; image_url?: string; image_alt?: string }>;

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          {c.section_label && <span style={{ display: 'block', fontSize: '0.875rem', fontWeight: 600, color: 'var(--brand-primary, #2563eb)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>{c.section_label}</span>}
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.5rem', letterSpacing: '-0.025em' }}
          >
            {sfHeadline(c, 'Features')}
          </InlineEditText>
        </div>
        {features.map((f, i) => (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center', marginBottom: 64 }}>
            <div style={{ order: i % 2 === 1 ? 1 : 0 }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: 12 }}>{f.title}</h3>
              <p style={{ color: 'var(--brand-text-light, #64748b)', lineHeight: 1.6 }}>{f.description}</p>
            </div>
            <div>
              {f.image_url ? (
                <img src={f.image_url} alt={f.image_alt || ''} style={{ width: '100%', borderRadius: 12, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -4px rgba(0,0,0,0.04)' }} />
              ) : (
                <div style={{ background: '#f1f5f9', borderRadius: 12, aspectRatio: '4/3' }} />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
export default FeaturesAlternating;
